import confetti from "canvas-confetti";

export const fireConfetti = (e) => {
  const x = e?.clientX ? e.clientX / window.innerWidth : 0.5;
  const y = e?.clientY ? e.clientY / window.innerHeight : 0.5;
  confetti({
    particleCount: 80,
    spread: 75,
    startVelocity: 32,
    origin: { x, y },
    colors: ["#c9006f", "#ffc4e4", "#91008d", "#ffffff"],
    scalar: 0.9,
    ticks: 180,
  });
};

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -128, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const isVideo = (src) => /\.(mp4|webm|mov)(\?|$)/i.test(src || "");

export const IMAGES = {
  leaves:
    "https://images.unsplash.com/photo-1491147334573-44cbb4602074?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHx0cm9waWNhbCUyMGdyZWVuJTIwbGVhdmVzJTIwZWxlZ2FudHxlbnwwfHx8fDE3ODU4MTY2NDd8MA&ixlib=rb-4.1.0&q=85",
};
